import { withSizes } from 'react-sizes';

import EntitiesBlock from './entities-block';
import { mapSizesToProps } from 'client/helpers/sizes';

export default withSizes(mapSizesToProps)(EntitiesBlock);
